import { useMutation } from 'react-query';
import { ScorecardService } from '../../../services/v1/applicant_tracking/ScorecardService';
import { Answer } from '../../../entities/v1/survey_engine/Answer';

export interface AnswerAttributeMutationData {
  scorecardId: number;
  answer: Answer;
}

export const useAnswerAttributeMutation = () =>
  useMutation<void, void, AnswerAttributeMutationData>({
    mutationFn: (data) =>
      ScorecardService.answerAttribute(data.scorecardId, data.answer),
  });
